// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpAccordion } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const Accordion = wrap(jpAccordion(), { events: { onChange: 'change' } });
// @ts-expect-error unknown property
Accordion.displayName = 'Jupyter.Accordion';
